import { useQuery } from "@tanstack/react-query";
import { getPublications } from "admin/rest_api";
import { Flex, Input, List, Spin } from "antd";
import PublicationCard from "dashboard/publication_card";
import { handleGenericError } from "libs/error_handling";
import { compareBy, filterWithSearchQueryAND } from "libs/utils";
import type React from "react";
import { useEffect, useState } from "react";
import type { APIPublication } from "types/api_types";

const { Search } = Input;

export function PublicationViewWithHeader() {
  const [searchQuery, setSearchQuery] = useState("");

  const {
    data: publications = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["publications"],
    queryFn: getPublications,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (error) {
      handleGenericError(error as Error);
    }
  }, [error]);

  function handleSearch(event: React.ChangeEvent<HTMLInputElement>) {
    setSearchQuery(event.target.value);
  }

  const search = (
    <Search
      style={{
        width: 200,
      }}
      placeholder="Search Publications"
      onChange={handleSearch}
      value={searchQuery}
    />
  );
  return (
    <div>
      <Flex justify="flex-end">{publications.length > 0 && search}</Flex>
      <Spin size="large" spinning={isLoading}>
        <div
          style={{
            minHeight: "100px",
          }}
        >
          <PublicationView publications={publications} searchQuery={searchQuery} />
        </div>
      </Spin>
    </div>
  );
}
type Props = {
  publications: Array<APIPublication>;
  searchQuery: string;
};

function PublicationView(props: Props) {
  const filteredPublications = filterWithSearchQueryAND(
    props.publications,
    [
      (model) => model.description,
      (model) => model.title,
      (model) =>
        model.datasets.flatMap((dataset) => [dataset.name, dataset.description, dataset.metadata]),
    ],
    props.searchQuery,
  ).sort(compareBy<APIPublication>((publication) => publication.publicationDate, false));

  return (
    <List
      dataSource={filteredPublications}
      locale={{
        emptyText: "No featured publications.",
      }}
      className="antd-no-border-list publication-list"
      renderItem={(publication) => (
        <List.Item key={publication.id}>
          <PublicationCard publication={publication} showDetailedLink />
        </List.Item>
      )}
    />
  );
}
